import __var_0__ from '@stdlib/utils/define-nonenumerable-read-only-property';
import __var_1__ from './main.js';
import __var_2__ from './object_mode.js';
import __var_3__ from './factory.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Create a readable stream for generating pseudorandom numbers via a linear congruential pseudorandom number generator (LCG) whose output is shuffled.
*
* @module @stdlib/random/streams/minstd-shuffle
*
* @example
* var inspectStream = require( '@stdlib/streams/node/inspect-sink' );
* var randomStream = require( '@stdlib/random/streams/minstd-shuffle' );
*
* function log( chunk ) {
*    console.log( chunk.toString() );
* }
*
* var opts = {
*     'iter': 10
* };
*
* var stream = randomStream( opts );
*
* stream.pipe( inspectStream( log ) );
*
* @example
* var randomStream = require( '@stdlib/random/streams/minstd-shuffle' );
*
* var opts = {
*     'sep': ',',
*     'objectMode': false,
*     'encoding': 'utf8',
*     'highWaterMark': 64
* };
*
* var createStream = randomStream.factory( opts );
*
* // Create 10 identically configured streams...
* var streams = [];
* var i;
* for ( i = 0; i < 10; i++ ) {
*     streams.push( createStream() );
* }
*
* @example
* var inspectStream = require( '@stdlib/streams/node/inspect-sink' );
* var randomStream = require( '@stdlib/random/streams/minstd-shuffle' );
*
* function log( v ) {
*    console.log( v );
* }
*
* var opts = {
*     'iter': 10
* };
*
* var stream = randomStream.objectMode( opts );
*
* stream.pipe( inspectStream.objectMode( log ) );
*/


// MODULES //
var setReadOnly = __var_0__;
var stream = __var_1__;
var objectMode = __var_2__;
var factory = __var_3__;


// MAIN //

setReadOnly( stream, 'objectMode', objectMode );
setReadOnly( stream, 'factory', factory );


// EXPORTS //
export default stream;
